import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { insights } from '../lib/insightsData';

const Insights = () => (
  <>
    <Helmet>
      <title>Website & Software Guides for Toronto Businesses | Nexgeius</title>
      <meta name="description" content="Practical guidance on website costs, custom software, and AI automation for Toronto businesses making a considered digital investment." />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://www.nexgeius.com/insights" />
    </Helmet>
    <main>
      <section className="bg-[#F1F4F4] px-6 pb-16 pt-28 lg:px-8 lg:pb-20 lg:pt-32">
        <div className="mx-auto max-w-7xl">
          <h1 className="max-w-3xl text-[clamp(3rem,6vw,5.4rem)] font-semibold leading-[.94] tracking-[-.06em] text-[#102A3A]">Useful guidance before you build.</h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-[#52636E]">Straight answers about the decisions, costs, and ownership details behind websites, software, and automation.</p>
        </div>
      </section>
      <section className="bg-white px-6 py-16 lg:px-8 lg:py-20">
        <div className="mx-auto max-w-7xl divide-y divide-[#DCE4E8] border-y border-[#DCE4E8]">
          {insights.map((insight) => (
            <article key={insight.slug} className="grid gap-5 py-8 md:grid-cols-[.22fr_.78fr] md:items-start">
              <p className="text-sm text-[#63747E]"><time dateTime={insight.publishedIso}>{insight.published}</time><br />{insight.readTime}</p>
              <div>
                <h2 className="max-w-3xl text-3xl font-semibold tracking-[-.04em] text-[#102A3A] md:text-4xl"><Link to={`/insights/${insight.slug}`} className="transition hover:text-[#176B8A]">{insight.title}</Link></h2>
                <p className="mt-4 max-w-2xl text-base leading-7 text-[#63747E]">{insight.description}</p>
                <Link to={`/insights/${insight.slug}`} className="mt-6 inline-flex text-sm font-semibold text-[#176B8A]">Read the guide <span className="ml-2" aria-hidden="true">→</span></Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  </>
);

export default Insights;
